/** Delay after last keystroke before orders search hits the API (web + mobile). */
export const ORDERS_SEARCH_DEBOUNCE_MS = 800;
